import { RouterModule, Routes } from '@angular/router';
import { BannerDemoComponent } from './banner/banner-demo.component';
import { MaterialButtonDemoComponent } from './material-button-demo/material-button-demo.component';
import { MaterialInputDemoComponent } from './material-input-demo/material-input-demo.component';
import { MaterialLandingPageComponent } from './material-landing-page/material-landing-page.component';
import { MaterialSelectDemoComponent } from './material-select-demo/material-select-demo.component';
import { MaterialTextareaDemoComponent } from './material-textarea-demo/material-textarea-demo.component';
import { PillDemoComponent } from './pill/pill-demo.component';
import { UnitsDemoComponent } from './units-demo/units-demo.component';
import { MaterialDatepickerDemoComponent } from './material-datepicker-demo/material-datepicker-demo.component';

export const materialDemoRoutes: Routes = [
  {
    path: 'uidemo',
    component: MaterialLandingPageComponent,
    children: [
      {
        path: 'mat-select',
        component: MaterialSelectDemoComponent,
        outlet: 'material',
      },
      {
        path: 'mat-input',
        component: MaterialInputDemoComponent,
        outlet: 'material',
      },
      {
        path: 'mat-datepicker',
        component: MaterialDatepickerDemoComponent,
        outlet: 'material',
      },
      {
        path: 'mat-textarea',
        component: MaterialTextareaDemoComponent,
        outlet: 'material',
      },
      {
        path: 'mat-button',
        component: MaterialButtonDemoComponent,
        outlet: 'material',
      },
      {
        path: 'banner',
        component: BannerDemoComponent,
        outlet: 'material',
      },
      {
        path: 'pill',
        component: PillDemoComponent,
        outlet: 'material',
      },
      {
        path: 'units',
        component: UnitsDemoComponent,
        outlet: 'material',
      },
    ],
  },
];

export const MaterialDemoRouting = RouterModule.forChild(materialDemoRoutes);
